import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Button } from '@material-ui/core';

import { Label } from 'core/components/label';
import { observer } from 'mobx-react';
import { useStore } from 'core/store/store.mobx';
import useSession from 'core/hooks/use-session';
import { track } from 'core/helpers/analytics';
import DialogError from '../dialog-error';

const PurchaseFailed = observer(({ errors, rejections, classes }) => {
  const { offer: store } = useStore();
  const { user, isAgency } = useSession();
  const onClick = () => {
    store.triggerOfferDialog(false);
  };

  // Bind was blocked or failed — fire the staff-user mirror of the BE
  // `Policy bind blocked` event so we can measure staff-driven bind failures
  // alongside the applicant funnel. This component only renders when the
  // offer-store sets PurchaseFailed/PreBindRejectionsBlocking, so a single
  // mount = a single bind-block event.
  useEffect(() => {
    track('Staff User: Policy Bind Blocked', {
      offerId: store?.offer?.id,
      webUserId: store?.offer?.webUserId,
      agent: user?.username,
      isAgency,
      offerStatus: store?.status,
      errors,
      rejections,
      rawBindErrorMessages: store?.rawBindErrorMessages
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Label type="titleSecondary" className={classes.title}>
        We were unable to complete the purchase
      </Label>
      {[...errors, ...rejections].map((error, index) => (
        <DialogError key={`${error.code}-${index}`} error={error} rawError={store.rawBindErrorMessages} />
      ))}
      <Grid container justifyContent="flex-end" className={classes.bottom}>
        <Button onClick={onClick} variant="contained" color="primary" className={classes.btn}>
          <Label className={classes.btnLabel}>Go back to checkout</Label>
        </Button>
      </Grid>
    </>
  );
});

PurchaseFailed.propTypes = {
  errors: PropTypes.array.isRequired,
  rejections: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired
};

export default PurchaseFailed;
